module.exports = __webpack_public_path__ + "static/img/googleplay.d29b02b6.png";